import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
  computed: {},
  methods: {},
  components: {},
})
export default class ConfirmAction extends Vue {
  @Prop(Boolean) readonly openModal;
  @Prop(String) readonly bfName;
  @Prop(Boolean) readonly isLoading;
  @Prop(Number) readonly state;

  @Emit('no') no() {}

  @Emit('yes') yes() {}
}
